// extracted by mini-css-extract-plugin
module.exports = {"BasePage__NavigationDesktop":"BasePage_BasePage__NavigationDesktop__2halh","BasePage__NavigationMobile":"BasePage_BasePage__NavigationMobile__HEbhP"};